import { render } from "./IVRAudioView.vue?vue&type=template&id=99f958d8&scoped=true"
import script from "./IVRAudioView.vue?vue&type=script&lang=js"
export * from "./IVRAudioView.vue?vue&type=script&lang=js"

import "./IVRAudioView.vue?vue&type=style&index=0&id=99f958d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99f958d8"]])

export default __exports__